module.exports = __webpack_public_path__ + "static/img/c-ph.f84de057.png";